import React from 'react';

const SvgComponent = (props) => (
  <svg viewBox="0 0 18 18" width="1em" height="1em" {...props}>
    <path d="M18 16.586l-4.542-4.542c2.248-2.94 2.034-7.159-.654-9.847C11.339.732 9.419 0 7.5 0S3.661.732 2.197 2.197a7.5 7.5 0 0 0 0 10.606A7.474 7.474 0 0 0 7.5 15a7.474 7.474 0 0 0 4.543-1.542L16.586 18 18 16.586zM7.5 13a5.464 5.464 0 0 1-3.889-1.611C2.572 10.35 2 8.969 2 7.5s.572-2.85 1.611-3.889C4.65 2.572 6.031 2 7.5 2s2.85.572 3.889 1.611C12.428 4.65 13 6.031 13 7.5s-.572 2.85-1.611 3.889A5.464 5.464 0 0 1 7.5 13z" />
  </svg>
);

export default SvgComponent;
